import { lazy, Suspense } from "react";
import { CustomerProvider } from "../../store/context/admin/customer-context.js";
import withProvider from "../../store/context/withProvider.js";
import { LoanRequestProvider } from "../../store/context/admin/loan-request-context.js";

import { TransactionProvider } from "../../store/context/admin/transaction-context.js";
// import { OrganisationProvider } from "../../store/context/admin/organisation-context.js";
import { ProductConfigurationProvider } from "../../store/context/admin/product-configuration-context.js";
import { LimitManagementProvider } from "../../pages/Requests/context/LimitManagementContext.js";
import { ProviderProvider } from "../../store/context/admin/provider-context.js";
import { AdminDashboardProvider } from "../../store/context/admin/dashboard-context.js";
import { DepositProvider } from "../../store/context/admin/deposit-context.js";
import { TransferProvider } from "../../store/context/admin/transfer-context.js";

export const ProtectedUserRoutes = [
  {
    path: "policies/*",
    element: lazy(() => import("../../components/Routes/PoliciesRoutes")),
  },
  {
    path: "policies/:policyId",
    element: withProvider(
      lazy(() => import("../../components/Policies/Policy")),
      [CustomerProvider],
    ),
  },

  {
    path: "/:quoteId",
    element: lazy(() => import("../../components/Dashboard/Quote")),
  },
  {
    path: "claims",
    element: lazy(() => import("../../components/Claims/Claims")),
  },

  {
    path: "requests/statement-request",
    element: lazy(() => import("../../pages/Requests/StatementForm")),
  },
  {
    path: "requests/contact-update-request",
    element: lazy(() => import("../../pages/Requests/ContactForm")),
  },
  {
    path: "requests/account-reactivation-request",
    element: lazy(
      () => import("../../pages/Requests/AccountReactivationForm.js"),
    ),
  },
  {
    path: "requests/account-deletion-request",
    element: lazy(
      () => import("../../pages/Requests/AccountDeletionRequestForm.js"),
    ),
  },
  {
    path: "requests/limit-management",
    element: withProvider(
      lazy(() => import("../../pages/Requests/LimitManagement.js")),
      [LimitManagementProvider],
    ),
  },
  {
    path: "requests",
    element: lazy(() => import("../../pages/Requests/RequestSelector")),
  }, //

  {
    path: "account-statement",
    element: lazy(
      () => import("../../pages/AccountStatement/AccountStatement.js"),
    ),
  },
  {
    path: "my-transactions",
    element: lazy(() => import("../../pages/Transactions/MyTransactions.js")),
  },
  {
    path: "my-transactions/:id",
    element: lazy(
      () => import("../../pages/Transactions/TransactionDetails.jsx"),
    ),
  },
  {
    path: "transfer/form",
    element: lazy(() => import("../../pages/Transfers/TransferForm")),
  },

  {
    path: "transfer",
    element: lazy(() => import("../../pages/Transfers/TransferType")),
  },
  {
    path: "airtime",
    element: lazy(() => import("../../pages/Airtime/AirtimeType")),
  },

  {
    path: "airtime/form",
    element: lazy(() => import("../../pages/Airtime/AirtimeForm")),
  },

  {
    path: "data",
    element: lazy(() => import("../../pages/Data/DataType")),
  },

  {
    path: "data/form",
    element: lazy(() => import("../../pages/Data/DataForm")),
  },
  {
    path: "bills-payment",
    element: lazy(() => import("../../pages/Bills/BillType")),
  }, //statement-request
  {
    path: "bills-payment/form",
    element: lazy(() => import("../../pages/Bills/BillForm")),
  },

  // ❌ Request Approval removed from here
  // Handled directly in AppRoutes.jsx before /dashboard/* catch-all
  // This prevents ProtectedLayout wrapper and allows component to handle its own auth

  {
    path: "loans",
    element: lazy(() => import("../../pages/Loan/LoanType")),
  },
  {
    path: "loans/:id",
    element: lazy(() => import("../../pages/Loan/LoanDetails.jsx")),
  },
  {
    path: "merchant-profile",
    element: lazy(
      () => import("../../pages/MerchantProfile/MerchantProfileSelector.js"),
    ),
  },
  {
    path: "merchant-accounts",
    element: lazy(
      () => import("../../pages/MerchantProfile/merchant_virtual_accounts.js"),
    ),
  },
  {
    path: "merchant-transactions",
    element: lazy(
      () => import("../../pages/MerchantProfile/MerchantVirtualTransaction.js"),
    ),
  },
  {
    path: "my-savings",
    element: lazy(() => import("../../pages/Savings/MySavings.js")),
  },
  {
    path: "my-savings/:id",
    element: lazy(() => import("../../pages/Savings/SavingsPlanDetails.jsx")),
  },
  {
    path: "my-savings/create",
    element: lazy(
      () => import("../../pages/Savings/SavingsPlanCreationForm.jsx"),
    ),
  },
  {
    path: "my-savings/top-up",
    element: lazy(() => import("../../pages/Savings/SavingsTopUp.jsx")),
  },
  {
    path: "my-savings/withdrawal",
    element: lazy(() => import("../../pages/Savings/SavingsWithdrawal.jsx")),
  },

  {
    path: "all-claims",
    element: lazy(() => import("../../components/Claims/AllClaims")),
  },
  {
    path: "claim-policy",
    element: lazy(() => import("../../components/Claims/ClaimPolicy")),
  },
  {
    path: "list-claims",
    element: lazy(() => import("../../components/Claims/ListClaims")),
  },
  {
    path: "form-claims",
    element: lazy(() => import("../../components/Claims/ClaimForm")),
  },
  {
    path: "extra-product-info",
    element: lazy(
      () => import("../../components/Extra Products Info/ExtraProductInfo.js"),
    ),
  },
  {
    path: "payments",
    element: lazy(() => import("../../components/Payments/Payments")),
  },
  {
    path: "payment-success",
    element: lazy(() => import("../../components/Payments/PaymentSuccess")),
  },
  {
    path: "transaction/:transactionId",
    element: lazy(() => import("../../components/Payments/Transaction")),
  },

  {
    path: "pay/with-account",
    element: lazy(
      () => import("../../components/Payment Methods/Pages/PayWithAccount.js"),
    ),
  },
  {
    path: "pay/with-card",
    element: lazy(
      () => import("../../components/Payment Methods/Pages/PayWithCard.js"),
    ),
  },
  {
    path: "pay/with-mobile-money",
    element: lazy(
      () =>
        import("../../components/Payment Methods/Pages/PayWithMobileMoney.js"),
    ),
  },
  {
    path: "pay/payment-otp",
    element: lazy(
      () => import("../../components/Payment Methods/Pages/PaymentOtp.js"),
    ),
  },

  {
    path: "pin/reset-otp",
    element: lazy(
      () =>
        import("../../pages/Settings And More/Personal Settings/ResetPinOTP.js"),
    ),
  },
  {
    path: "pin/reset-complete",
    element: lazy(
      () =>
        import("../../pages/Settings And More/Personal Settings/ResetPin.js"),
    ),
  },
];

export const ProtectedAdminRoutes = [
  // Admin routes
  {
    path: "admin-dashboard",
    element: withProvider(
      lazy(() => import("../../pages/Admin/Dashboard/AdminDashboard.js")),
      [AdminDashboardProvider],
    ),
  },
  {
    path: "general-search",
    element: lazy(
      () => import("../../pages/Admin/GeneralSearch/GeneralSearch.js"),
    ),
  },
  {
    path: "customers-report",
    element: withProvider(
      lazy(() => import("../../pages/Admin/Customers/AdminCustomer.js")),
      [CustomerProvider],
    ),
  },
  {
    path: "liveness-check",
    element: withProvider(
      lazy(() => import("../../pages/Admin/LivenessCheck/LivenessCheck.js")),
      [CustomerProvider],
    ),
  },
  {
    path: "ip-blacklist",
    code: "ipBlacklistChannels",
    element: lazy(() => import("../../pages/Admin/Security/IpBlacklistManagement.jsx")),
  },
  {
    path: "account-blacklist",
    code: "accountBlacklistChannels",
    element: lazy(() => import("../../pages/Admin/Security/AccountPndManagement.jsx")),
  },
  {
    path: "customers-report/:userId",
    element: withProvider(
      lazy(() => import("../../pages/Admin/Customers/AdminCustomerDetails.js")),
      [CustomerProvider],
    ),
  },

  {
    path: "pending-merchant/:userId",
    element: withProvider(
      lazy(
        () =>
          import("../../pages/Admin/Customers/AdminPendingCustomerDetails.js"),
      ),
      [CustomerProvider],
    ),
  },

  {
    path: "create-merchant",
    element: withProvider(
      lazy(() => import("../../pages/Admin/Merchants/AdminNewMerchant.js")),
      [CustomerProvider],
    ),
  },
  {
    path: "merchant/:customerId",
    element: withProvider(
      lazy(() => import("../../pages/Admin/Merchants/AdminNewMerchant.js")),
      [CustomerProvider],
    ),
  },
  {
    path: "merchant/:customerId/edit",
    element: withProvider(
      lazy(() => import("../../pages/Admin/Merchants/AdminNewMerchant.js")),
      [CustomerProvider],
    ),
  },

  {
    path: "terminal/:userId",
    element: withProvider(
      lazy(() => import("../../pages/Admin/Terminals/AdminNewTerminals.js")),
      [CustomerProvider],
    ),
  },
  {
    path: "terminal/:userId/edit",
    element: withProvider(
      lazy(() => import("../../pages/Admin/Terminals/AdminNewTerminals.js")),
      [CustomerProvider],
    ),
  },
  {
    path: "merchant-lists",
    element: withProvider(
      lazy(() => import("../../pages/Admin/Merchants/AdminMerchant.js")),
      [CustomerProvider],
    ),
  },
  {
    path: "contact-lists",
    element: withProvider(
      lazy(() => import("../../pages/Admin/Contacts/AdminContacts.js")),
      [CustomerProvider],
    ),
  },
  {
    path: "terminals",
    element: withProvider(
      lazy(() => import("../../pages/Admin/Terminals/AdminTerminals.js")),
      [CustomerProvider],
    ),
  },
  {
    path: "virtual-accounts",
    element: withProvider(
      lazy(
        () =>
          import("../../pages/Admin/VirtualAccounts/AdminVirtualAccounts.js"),
      ),
      [CustomerProvider],
    ),
  },
  {
    path: "create-virtual-account",
    element: withProvider(
      lazy(
        () =>
          import("../../pages/Admin/VirtualAccounts/AdminNewVirtualAccount.js"),
      ),
      [CustomerProvider],
    ),
  },
  {
    path: "virtual-accounts/:virtualAccountId",
    element: withProvider(
      lazy(
        () =>
          import("../../pages/Admin/VirtualAccounts/AdminNewVirtualAccount.js"),
      ),
      [CustomerProvider],
    ),
  },
  {
    path: "virtual-accounts/:virtualAccountId/edit",
    element: withProvider(
      lazy(
        () =>
          import("../../pages/Admin/VirtualAccounts/AdminNewVirtualAccount.js"),
      ),
      [CustomerProvider],
    ),
  },
  {
    path: "new-terminal",
    element: withProvider(
      lazy(() => import("../../pages/Admin/Terminals/AdminNewTerminals.js")),
      [CustomerProvider],
    ),
  },
  {
    path: "communications",
    element: withProvider(
      lazy(() => import("../../pages/Admin/Contacts/AdminCommunication.js")),
      [CustomerProvider],
    ),
  },
  {
    path: "Policies",
    element: withProvider(
      lazy(() => import("../../pages/Admin/Policies/AdminPolicies.js")),
      [CustomerProvider],
    ),
  },
  {
    path: "admin-claims",
    element: withProvider(
      lazy(() => import("../../pages/Admin/Claims/AdminClaims.js")),
      [CustomerProvider],
    ),
  },
  {
    path: "new-claim",
    element: withProvider(
      lazy(() => import("../../pages/Admin/Claims/AdminNewClaim.js")),
      [CustomerProvider],
    ),
  },
  {
    path: "rule-table",
    element: withProvider(
      lazy(
        () =>
          import("../../components/Settings/DeveloperTools/Tabs/TablesTab.js"),
      ),
      [CustomerProvider],
    ),
  },

  {
    path: "batch-posting",
    element: lazy(
      () => import("../../pages/Admin/BatchPosting/AdminBatchPosting.js"),
    ),
  },
  {
    path: "branch-vault",
    element: lazy(
      () => import("../../pages/Admin/Tellering/BranchVault/Vaults.js"),
    ),
  },
  {
    path: "branch-vault/:tillId",
    element: lazy(
      () => import("../../pages/Admin/Tellering/BranchVault/VaultView.js"),
    ),
  },
  {
    path: "branch-vaults-transactions",
    element: lazy(
      () =>
        import("../../pages/Admin/Tellering/BranchVault/VaultTransactions.js"),
    ),
  },
  {
    path: "reconciliation",
    element: lazy(
      () => import("../../pages/Admin/Reconcillation/Reconcillation.js"),
    ),
  },
  {
    path: "reconciliation/:id",
    element: lazy(
      () => import("../../pages/Admin/Reconcillation/ReconcillationDetail.js"),
    ),
  },
  {
    path: "new-reconciliation",
    element: lazy(
      () => import("../../pages/Admin/Reconcillation/ReconcillationJobzNew.js"),
    ),
  },

  // /
  {
    path: "sil-customer-accounts",
    element: withProvider(
      lazy(() => import("../../pages/Admin/SIL/Accounts/SilAccounts.js")),
      [CustomerProvider],
    ),
  },
  {
    path: "view-sil-accounts/:accountId",
    element: withProvider(
      lazy(() => import("../../pages/Admin/SIL/Accounts/AccountView.js")),
      [CustomerProvider],
    ),
  },
  {
    path: "sil-till-transactions",
    element: withProvider(
      lazy(
        () => import("../../pages/Admin/SIL/Transactions/SILTransactionTab.js"),
      ),
      [CustomerProvider],
    ),
  },

  {
    path: "tills",
    element: withProvider(
      lazy(() => import("../../pages/Admin/Tellering/TillManagement/Tills.js")),
      [CustomerProvider],
    ),
  },
  {
    path: "view-till/:tillId",
    element: withProvider(
      lazy(
        () => import("../../pages/Admin/Tellering/TillManagement/TillView.js"),
      ),
      [CustomerProvider],
    ),
  },
  {
    path: "teller-transaction",
    element: withProvider(
      lazy(
        () => import("../../pages/Admin/Tellering/TelleringTransactionTab.js"),
      ),
      [CustomerProvider],
    ),
  },

  {
    path: "teller-search",
    element: withProvider(
      lazy(() => import("../../pages/Admin/Tellering/TelleringSearch.js")),
      [CustomerProvider],
    ),
  },

  {
    path: "teller-dashboard",
    element: withProvider(
      lazy(() => import("../../pages/Admin/Tellering/TelleringDashboard.js")),
      [CustomerProvider],
    ),
  },

  {
    path: "sil-tellering-dashboard",
    element: withProvider(
      lazy(() => import("../../pages/Admin/SIL/SilTelleringDashboard.js")),
      [CustomerProvider],
    ),
  },
  {
    path: "business-rules",
    element: withProvider(
      lazy(
        () =>
          import("../../components/Settings/DeveloperTools/Tabs/BusinessRuleTab.js"),
      ),
      [CustomerProvider],
    ),
  },

  {
    path: "Process",
    element: withProvider(
      lazy(
        () =>
          import("../../components/Settings/DeveloperTools/Tabs/processTab.js"),
      ),
      [CustomerProvider],
    ),
  },
  {
    path: "object-definitions",
    element: withProvider(
      lazy(
        () =>
          import("../../components/Settings/DeveloperTools/Tabs/ObjectDefinitionsTab.js"),
      ),
      [CustomerProvider],
    ),
  },
  {
    path: "general-config",
    element: withProvider(
      lazy(
        () =>
          import("../../components/Settings/DeveloperTools/Tabs/GeneralConfigPage.jsx"),
      ),
      [CustomerProvider],
    ),
  },

  {
    path: "schema",
    element: withProvider(
      lazy(
        () =>
          import("../../components/Settings/DeveloperTools/Tabs/SchemaTab.js"),
      ),
      [CustomerProvider],
    ),
  },

  {
    path: "platform-configuration",
    element: withProvider(
      lazy(
        () =>
          import("../../components/Settings/DeveloperTools/Tabs/PlatformTab.js"),
      ),
      [CustomerProvider],
    ),
  },
  {
    path: "process-launcher",
    element: withProvider(
      lazy(() => import("../../pages/Admin/Process/AdminProcessInstances.js")),
      [CustomerProvider],
    ),
  },
  {
    path: "process-launcher/:instanceGuid",
    element: withProvider(
      lazy(
        () => import("../../pages/Admin/Process/AdminProcessInstancesGuid.js"),
      ),
      [CustomerProvider],
    ),
  },
  {
    path: "process-launcher-2",
    element: withProvider(
      lazy(
        () =>
          import("../../components/Settings/DeveloperTools/Tabs/ProcessTesting.js"),
      ),
      [CustomerProvider],
    ),
  },
  {
    path: "recurring-jobs",
    element: lazy(
      () =>
        import("../../components/Settings/DeveloperTools/Tabs/RecurringJob.js"),
    ),
  },

  {
    path: "html-templates",
    element: withProvider(
      lazy(
        () =>
          import("../../components/Settings/DeveloperTools/Tabs/HtmlTab.js"),
      ),
      [CustomerProvider],
    ),
  },
  {
    path: "insurance",
    element: lazy(
      () =>
        import("../../components/Settings/DeveloperTools/Tabs/InsuranceTab.js"),
    ),
  },
  {
    path: "financial-products",
    element: lazy(
      () =>
        import("../../components/Settings/DeveloperTools/Tabs/DepositTab.js"),
    ),
  },
  {
    path: "loan-products",
    element: lazy(
      () => import("../../components/Settings/DeveloperTools/Tabs/LoanTab.js"),
    ),
  },
  {
    path: "audit-logs",
    element: withProvider(
      lazy(
        () =>
          import("../../components/Settings/DeveloperTools/Tabs/AuditLogTab.js"),
      ),
      [CustomerProvider],
    ),
  },
  {
    path: "system-logs",
    element: withProvider(
      lazy(
        () =>
          import("../../components/Settings/DeveloperTools/Tabs/SystemLogTab.js"),
      ),
      [CustomerProvider],
    ),
  },
  {
    path: "languages",
    element: withProvider(
      lazy(
        () =>
          import("../../components/Settings/DeveloperTools/Tabs/LanguageManagement.js"),
      ),
      [CustomerProvider],
    ),
  },
  {
    path: "forms",
    element: lazy(
      () =>
        import("../../components/Settings/DeveloperTools/Tabs/FormBuilder.js"),
    ),
  },
  {
    path: "forms/new",
    element: lazy(
      () =>
        import("../../components/Settings/DeveloperTools/Tabs/FormBuilder.js"),
    ),
  },
  {
    path: "forms/:formId/edit",
    element: lazy(
      () =>
        import("../../components/Settings/DeveloperTools/Tabs/FormBuilder.js"),
    ),
  },
  {
    path: "views",
    element: withProvider(
      lazy(
        () =>
          import("../../components/Settings/DeveloperTools/Tabs/CustomViewTab.js"),
      ),
      [CustomerProvider],
    ),
  },
  {
    path: "custom-views",
    element: withProvider(
      lazy(
        () =>
          import("../../components/Settings/DeveloperTools/Tabs/CustomViewTab.js"),
      ),
      [CustomerProvider],
    ),
  },
  {
    path: "custom-views/new",
    element: withProvider(
      lazy(
        () =>
          import("../../components/Settings/DeveloperTools/Tabs/CustomViewTab.js"),
      ),
      [CustomerProvider],
    ),
  },
  {
    path: "custom-views/:viewId",
    element: withProvider(
      lazy(
        () =>
          import("../../components/Settings/DeveloperTools/Tabs/CustomViewTab.js"),
      ),
      [CustomerProvider],
    ),
  },
  {
    path: "custom-views/:viewId/edit",
    element: withProvider(
      lazy(
        () =>
          import("../../components/Settings/DeveloperTools/Tabs/CustomViewTab.js"),
      ),
      [CustomerProvider],
    ),
  },
  {
    path: "document-template",
    element: withProvider(
      lazy(
        () =>
          import("../../components/Settings/DeveloperTools/Tabs/DocumentTemplateTab.js"),
      ),
      [CustomerProvider],
    ),
  },
  {
    path: "document-template/new",
    element: withProvider(
      lazy(
        () =>
          import("../../components/Settings/DeveloperTools/Tabs/DocumentTemplateTab.js"),
      ),
      [CustomerProvider],
    ),
  },
  {
    path: "document-template/:templateId",
    element: withProvider(
      lazy(
        () =>
          import("../../components/Settings/DeveloperTools/Tabs/DocumentTemplateTab.js"),
      ),
      [CustomerProvider],
    ),
  },
  {
    path: "document-template/:templateId/edit",
    element: withProvider(
      lazy(
        () =>
          import("../../components/Settings/DeveloperTools/Tabs/DocumentTemplateTab.js"),
      ),
      [CustomerProvider],
    ),
  },
  {
    path: "acturial-sheets",
    element: withProvider(
      lazy(
        () =>
          import("../../components/Settings/DeveloperTools/Tabs/ActurialSheetTab.js"),
      ),
      [CustomerProvider],
    ),
  },
  {
    path: "acturial-sheets/new",
    element: withProvider(
      lazy(
        () =>
          import("../../components/Settings/DeveloperTools/Tabs/ActurialSheetTab.js"),
      ),
      [CustomerProvider],
    ),
  },
  {
    path: "acturial-sheets/:sheetId",
    element: withProvider(
      lazy(
        () =>
          import("../../components/Settings/DeveloperTools/Tabs/ActurialSheetTab.js"),
      ),
      [CustomerProvider],
    ),
  },
  {
    path: "acturial-sheets/:sheetId/edit",
    element: withProvider(
      lazy(
        () =>
          import("../../components/Settings/DeveloperTools/Tabs/ActurialSheetTab.js"),
      ),
      [CustomerProvider],
    ),
  },

  {
    path: "new-contact",
    element: withProvider(
      lazy(() => import("../../pages/Admin/Contacts/AdminNewCustomer.js")),
      [CustomerProvider],
    ),
  },

  {
    path: "inward-transactions",
    element: lazy(
      () =>
        import("../../pages/Admin/TransactionMonitoring/InwardTransactionTab.jsx"),
    ),
  },
  {
    path: "direct-configuration/:id",
    element: lazy(
      () =>
        import("../../pages/Admin/TransactionMonitoring/configurationsTab.jsx"),
    ),
  },
  {
    path: "direct-configuration/:id/edit",
    element: lazy(
      () =>
        import("../../pages/Admin/TransactionMonitoring/configurationsTab.jsx"),
    ),
  },
  {
    path: "evaluate-alert",
    element: lazy(
      () => import("../../pages/Admin/TransactionMonitoring/EvaluateAlert.jsx"),
    ),
  },
  {
    path: "alert/:id",
    element: lazy(
      () =>
        import("../../pages/Admin/TransactionMonitoring/AdminMonitoringAlertDetails.js"),
    ),
  },
  {
    path: "alert-monitoring",
    element: lazy(
      () =>
        import("../../pages/Admin/TransactionMonitoring/MonitoringAlertTable.jsx"),
    ),
  },
  {
    path: "outward-transactions",
    element: lazy(
      () =>
        import("../../pages/Admin/TransactionMonitoring/OutwardTransactionTab.jsx"),
    ),
  },

  {
    path: "data-Ingestion",
    element: lazy(
      () => import("../../pages/Admin/TransactionMonitoring/DataIngestion.jsx"),
    ),
  },

  // NPS Management (Operations)
  {
    path: "nps-inward-debit-requests",
    element: lazy(
      () => import("../../pages/Admin/NPS/NpsInwardDebitRequests.jsx"),
    ),
  },
  {
    path: "nps-inward-debit-requests/:id",
    element: lazy(
      () => import("../../pages/Admin/NPS/NpsInwardDebitRequestDetail.jsx"),
    ),
  },
  {
    path: "nps-mandates",
    element: lazy(() => import("../../pages/Admin/NPS/NpsMandates.jsx")),
  },
  {
    path: "nps-mandates/:id",
    element: lazy(() => import("../../pages/Admin/NPS/NpsMandateDetail.jsx")),
  },
  {
    path: "nps-account-reports",
    element: lazy(() => import("../../pages/Admin/NPS/NpsAccountReports.jsx")),
  },
  {
    path: "nps-account-reports/:id",
    element: lazy(
      () => import("../../pages/Admin/NPS/NpsAccountReportDetail.jsx"),
    ),
  },
  {
    path: "nps-request-to-pay",
    element: lazy(() => import("../../pages/Admin/NPS/NpsRequestToPay.jsx")),
  },
  {
    path: "nps-request-to-pay/:id",
    element: lazy(
      () => import("../../pages/Admin/NPS/NpsRequestToPayDetail.jsx"),
    ),
  },
  {
    path: "branches",
    element: withProvider(
      lazy(() => import("../../pages/Admin/Branches/AdminBranches.js")),
      [CustomerProvider],
    ),
  },
  {
    path: "closures",
    element: withProvider(
      lazy(() => import("../../pages/Admin/Branches/AdminBranchClosures.js")),
      [CustomerProvider],
    ),
  },
  {
    path: "create-branch",
    element: withProvider(
      lazy(() => import("../../pages/Admin/Branches/AdminNewBranches.js")),
      [CustomerProvider],
    ),
  },
  {
    path: "branch-management/:branchId",
    element: withProvider(
      lazy(() => import("../../pages/Admin/Branches/AdminNewBranches.js")),
      [CustomerProvider],
    ),
  },
  {
    path: "journals",
    element: withProvider(
      lazy(
        () => import("../../pages/Admin/JournalEntries/AdminJournalEntries.js"),
      ),
      [CustomerProvider],
    ),
  },
  {
    path: "journal-transactions",
    element: withProvider(
      lazy(
        () =>
          import("../../pages/Admin/JournalEntries/AdminJournalTransactions.js"),
      ),
      [CustomerProvider],
    ),
  },
  {
    path: "journals-entry",
    element: withProvider(
      lazy(
        () =>
          import("../../pages/Admin/JournalEntries/AdminNewJournalEntries.js"),
      ),
      [CustomerProvider],
    ),
  },
  {
    path: "chart-of-accounts",
    element: withProvider(
      lazy(
        () =>
          import("../../pages/Admin/ChartsOfAccounnts/AdminChartsOfAccounts.js"),
      ),
      [CustomerProvider],
    ),
  },
  {
    path: "coa-management",
    element: withProvider(
      lazy(
        () => import("../../pages/Admin/ChartsOfAccounnts/AdminNewCharts.js"),
      ),
      [CustomerProvider],
    ),
  },
  {
    path: "contact/:customerId",
    element: withProvider(
      lazy(() => import("../../pages/Admin/Contacts/AdminNewCustomer.js")),
      [CustomerProvider],
    ),
  },
  {
    path: "contact/:customerId/edit",
    element: withProvider(
      lazy(() => import("../../pages/Admin/Contacts/AdminNewCustomer.js")),
      [CustomerProvider],
    ),
  },

  {
    path: "uncleared-cheques",
    element: withProvider(
      lazy(
        () =>
          import("../../pages/Admin/cheques-clearing/Uncleared-cheques.jsx"),
      ),
      [CustomerProvider],
    ),
  },

  {
    path: "cheque-transactions",
    element: withProvider(
      lazy(
        () =>
          import("../../pages/Admin/cheques-clearing/cheques-transactions.js"),
      ),
      [CustomerProvider],
    ),
  },
  {
    path: "create-policy",
    element: withProvider(
      lazy(() => import("../../pages/Admin/Policies/AdminNewPolicy.js")),
      [CustomerProvider],
    ),
  },

  {
    path: "loan-requests-report",
    element: withProvider(
      lazy(() => import("../../pages/Admin/LoanRequests/AdminLoanRequest.js")),
      [ProductConfigurationProvider],
    ),
  },
  {
    // Optional param, not a separate route entry — two <Route>s here would
    // remount the page (and lose form state) every time we push the userId
    // onto the URL after a search.
    path: "new-loan-request/:userId?",
    element: withProvider(
      lazy(
        () => import("../../pages/Admin/LoanRequests/AdminNewLoanRequest.jsx"),
      ),
      [TransferProvider],
    ),
  },
  {
    path: "loan-requests-report/:loanId",
    element: withProvider(
      lazy(
        () =>
          import("../../pages/Admin/LoanRequests/AdminLoanRequestDetails.js"),
      ),
      [CustomerProvider],
    ),
  },
  {
    path: "transactions-report",
    element: withProvider(
      lazy(() => import("../../pages/Admin/Transactions/AdminTransaction.js")),
      [TransactionProvider],
    ),
  },
  {
    path: "terminals-transactions",
    element: withProvider(
      lazy(
        () =>
          import("../../pages/Admin/Terminals/AdminTerminalsTransaction.js"),
      ),
      [TransactionProvider],
    ),
  },

  {
    path: "transactions-report/:transactionId",
    element: withProvider(
      lazy(
        () =>
          import("../../pages/Admin/Transactions/AdminTransactionDetails.js"),
      ),
      [CustomerProvider],
    ),
  },
  {
    path: "ptsp-transactions-report/:transactionId",
    element: withProvider(
      lazy(
        () =>
          import("../../pages/Admin/Transactions/AdminPtspTransactionDetails.js"),
      ),
      [CustomerProvider],
    ),
  },
  {
    path: "deposit-transactions",
    element: withProvider(
      lazy(
        () =>
          import("../../pages/Admin/Transactions/AdminDepositTransactions.js"),
      ),
      [TransactionProvider],
    ),
  },
  {
    path: "journal-transaction/:transactionId",
    element: withProvider(
      lazy(
        () =>
          import("../../pages/Admin/JournalEntries/AdminJournalTransactionDetails.js"),
      ),
      [TransactionProvider],
    ),
  },
  {
    path: "core-transactions/:transactionId",
    element: withProvider(
      lazy(
        () =>
          import("../../pages/Admin/Transactions/AdminCoreTransactionDetails.js"),
      ),
      [TransactionProvider],
    ),
  },
  {
    path: "sil-transactions/:transactionId",
    element: withProvider(
      lazy(
        () =>
          import("../../pages/Admin/Transactions/AdminSILTransactionDetails.js"),
      ),
      [TransactionProvider],
    ),
  },
  {
    path: "monitor-transactions/:transactionId",
    element: withProvider(
      lazy(
        () =>
          import("../../pages/Transactions/MonitoringTransactionDetails.jsx"),
      ),
      [TransactionProvider],
    ),
  },
  {
    path: "loan-transactions",
    element: withProvider(
      lazy(
        () => import("../../pages/Admin/Transactions/AdminLoanTransaction.js"),
      ),
      [TransactionProvider],
    ),
  },
  {
    path: "loan-repayment",
    element: withProvider(
      lazy(
        () => import("../../pages/Admin/LoanRequests/AdminLoanRepayment.js"),
      ),
      [TransactionProvider],
    ),
  },
  {
    path: "disburse-loan",
    element: withProvider(
      lazy(
        () => import("../../pages/Admin/LoanRequests/AdminLoanDisbursement.js"),
      ),
      [TransactionProvider],
    ),
  },
  {
    path: "write-off-loan",
    element: withProvider(
      lazy(() => import("../../pages/Admin/LoanRequests/AdminLoanWriteOff.js")),
      [TransactionProvider],
    ),
  },
  {
    path: "refinance-loan",
    element: withProvider(
      lazy(
        () => import("../../pages/Admin/LoanRequests/AdminLoanRefinance.js"),
      ),
      [TransactionProvider],
    ),
  },
  {
    path: "reschedule-loan",
    element: withProvider(
      lazy(
        () => import("../../pages/Admin/LoanRequests/AdminLoanReschedule.js"),
      ),
      [TransactionProvider],
    ),
  },
  {
    path: "pay-off-loan",
    element: withProvider(
      lazy(() => import("../../pages/Admin/LoanRequests/AdminLoanPayOff.js")),
      [TransactionProvider],
    ),
  },
  {
    path: "transfers-report",
    element: lazy(() => import("../../pages/Admin/Transfers/AdminTransfer.js")),
  },
  {
    path: "transfers-report/:transactionId",
    element: lazy(
      () => import("../../pages/Admin/Transfers/AdminTransferDetails.js"),
    ),
  },

  {
    path: "/remita-loan-requests",
    element: lazy(
      () => import("../../pages/Admin/Remita/AdminRemitaLoanRequests.jsx"),
    ),
  },
  {
    path: "/remita-loan-requests/:requestId",
    element: lazy(
      () => import("../../pages/Admin/Remita/AdminRemitaLoanRequestView.jsx"),
    ),
  },
  {
    path: "/remita-collection-batches",
    element: lazy(
      () => import("../../pages/Admin/Remita/AdminRemitaCollectionBatches.jsx"),
    ),
  },
  {
    path: "/remita-collection-batches/:batchId",
    element: lazy(
      () =>
        import("../../pages/Admin/Remita/AdminRemitaCollectionBatchView.jsx"),
    ),
  },
  {
    path: "/remita-new-batch",
    element: lazy(
      () => import("../../pages/Admin/Remita/AdminRemitaNewBatch.jsx"),
    ),
  },
  {
    path: "/remita-prequalification",
    element: lazy(
      () => import("../../pages/Admin/Remita/AdminRemitaPrequalification.jsx"),
    ),
  },
  {
    path: "/remita-collections",
    element: lazy(
      () => import("../../pages/Admin/Remita/AdminRemitaCollections.jsx"),
    ),
  },
  {
    path: "/remita-collections/:collectionId",
    element: lazy(
      () => import("../../pages/Admin/Remita/AdminRemitaCollectionView.jsx"),
    ),
  },
  // Disbursement pages
  {
    path: "/disbursement-batches",
    element: lazy(
      () =>
        import("../../pages/Admin/Disbursement/AdminDisbursementBatches.jsx"),
    ),
  },
  {
    path: "/disbursement-batches/:batchId",
    element: lazy(
      () =>
        import("../../pages/Admin/Disbursement/AdminDisbursementBatchView.jsx"),
    ),
  },
  {
    path: "/disbursements",
    element: lazy(
      () =>
        import("../../pages/Admin/Disbursement/AdminDisbursementReport.jsx"),
    ),
  },
  {
    path: "/disbursements/:disbursementId",
    element: lazy(
      () =>
        import("../../pages/Admin/Disbursement/AdminSingleDisbursementDetails.jsx"),
    ),
  },
  {
    path: "/new-disbursement",
    element: lazy(
      () => import("../../pages/Admin/Disbursement/AdminNewDisbursement.jsx"),
    ),
  },
  {
    path: "/new-disbursement/:disbursementId",
    element: lazy(
      () => import("../../pages/Admin/Disbursement/AdminNewDisbursement.jsx"),
    ),
  },
  {
    path: "/new-disbursement/:disbursementId/edit",
    element: lazy(
      () => import("../../pages/Admin/Disbursement/AdminNewDisbursement.jsx"),
    ),
  },
  {
    path: "/new-disbursement-batch",
    element: lazy(
      () =>
        import("../../pages/Admin/Disbursement/AdminNewDisbursementBatch.jsx"),
    ),
  },

  {
    path: "/mandate/selector",
    element: lazy(
      () => import("../../pages/Admin/Mandate/MandateSelector.jsx"),
    ),
  },
  {
    path: "/mandate/view-mandate/:mandateReference",
    element: lazy(() => import("../../pages/Admin/Mandate/ViewMandate.jsx")),
  },

  {
    path: "/mandate/view-collection/:collectionId",
    element: lazy(() => import("../../pages/Admin/Mandate/ViewCollection.jsx")),
  },

  {
    path: "/mandate/view-batch/:id",
    element: lazy(() => import("../../pages/Admin/Mandate/ViewBatch.jsx")),
  },
  {
    path: "/mandate/collection-report",
    element: lazy(
      () => import("../../pages/Admin/Mandate/AdminCollectionsReport.jsx"),
    ),
  },
  // {
  //   path: "/mandate/collection-report",
  //   element: lazy(() =>
  //     import("../../pages/Admin/Mandate/AdminCollectionsReport.jsx")
  //   ),
  // },
  {
    path: "/mandate/upload-mandate",
    element: lazy(() => import("../../pages/Admin/Mandate/UploadDetails.jsx")),
  },
  {
    path: "/collection/initiate-batch-form",
    element: lazy(
      () => import("../../pages/Admin/Mandate/AdminCollectionBatchForm.jsx"),
    ),
  },

  {
    path: "/collection/reports",
    element: lazy(
      () => import("../../pages/Admin/Mandate/AdminBatchReport.jsx"),
    ),
  },
  {
    path: "/collection-batches-nibss",
    element: lazy(
      () => import("../../pages/Admin/Mandate/AdminBatchReportNibss.jsx"),
    ),
  },
  {
    path: "/collection-batches-nibss/:batchId",
    element: lazy(
      () =>
        import("../../pages/Admin/Mandate/AdminCollectionBatchViewNibss.jsx"),
    ),
  },
  {
    path: "/new-collection-batch-nibss",
    element: lazy(
      () =>
        import("../../pages/Admin/Mandate/AdminNewCollectionBatchNibss.jsx"),
    ),
  },
  {
    path: "/collections-nibss",
    element: lazy(
      () => import("../../pages/Admin/Mandate/AdminCollectionsReportNibss.jsx"),
    ),
  },
  {
    path: "/collections-nibss/:collectionId",
    element: lazy(
      () => import("../../pages/Admin/Mandate/AdminCollectionViewNibss.jsx"),
    ),
  },
  {
    path: "/collection/initiate-single-form",
    element: lazy(
      () => import("../../pages/Admin/Mandate/AdminCollectionSingleForm.jsx"),
    ),
  },

  {
    path: "/mandate-reports",
    element: lazy(
      () => import("../../pages/Admin/Mandate/AdminMandatesReport.jsx"),
    ),
  },

  {
    path: "/mandate-batches-reports",
    element: lazy(
      () => import("../../pages/Admin/Mandate/AdminMandatesBatchesReport.jsx"),
    ),
  },

  // NIBSS Mandate reports (separate pages for NIBSS)
  {
    path: "/mandate-reports-nibss",
    element: lazy(
      () => import("../../pages/Admin/Mandate/AdminMandatesReportNibss.jsx"),
    ),
  },
  {
    path: "/mandate-reports-nibss/:mandateReference",
    element: lazy(
      () => import("../../pages/Admin/Mandate/AdminMandateViewNibss.jsx"),
    ),
  },
  {
    path: "/mandate-batches-reports-nibss",
    element: lazy(
      () =>
        import("../../pages/Admin/Mandate/AdminMandatesBatchesReportNibss.jsx"),
    ),
  },
  {
    path: "/new-mandate-batch-nibss",
    element: lazy(
      () => import("../../pages/Admin/Mandate/AdminNewMandateBatchNibss.jsx"),
    ),
  },
  {
    path: "/mandate-batches-reports-nibss/:batchId",
    element: lazy(
      () => import("../../pages/Admin/Mandate/AdminMandateBatchViewNibss.jsx"),
    ),
  },

  {
    path: "/new-mandate-nibss",
    element: lazy(
      () => import("../../pages/Admin/Mandate/AdminNewMandateNibss.jsx"),
    ),
  },

  {
    path: "/employees",
    element: lazy(
      () => import("../../pages/Admin/Employees/AdminEmployees.jsx"),
    ),
  },
  {
    path: "/employees/:employeeId",
    element: lazy(
      () => import("../../pages/Admin/Employees/AdminNewEmployee.jsx"),
    ),
  },
  {
    path: "/employees/:employeeId/edit",
    element: lazy(
      () => import("../../pages/Admin/Employees/AdminNewEmployee.jsx"),
    ),
  },
  {
    path: "/new-employee",
    element: lazy(
      () => import("../../pages/Admin/Employees/AdminNewEmployee.jsx"),
    ),
  },
  {
    path: "/upload-employees",
    element: lazy(
      () => import("../../pages/Admin/Employees/AdminUploadEmployees.jsx"),
    ),
  },
  {
    path: "/referrals",
    element: lazy(
      () => import("../../pages/Admin/Employees/AdminReferrals.jsx"),
    ),
  },

  {
    path: "/create-mandate",
    element: lazy(
      () => import("../../pages/Admin/Mandate/AdminMandatesForm.jsx"),
    ),
  },

  {
    path: "general-requests/others",
    element: lazy(
      () => import("../../pages/Admin/GeneralRequests/GeneralRequest.js"),
    ),
  },

  {
    path: "general-requests-selector",
    element: lazy(
      () => import("../../pages/Admin/GeneralRequests/RequestSelector.js"),
    ),
  },

  {
    path: "general-requests/limit-requests",
    element: lazy(
      () => import("../../pages/Admin/GeneralRequests/limits/LimitRequest.js"),
    ),
  },
  {
    path: "general-requests/account-reactivations",
    element: lazy(
      () =>
        import("../../pages/Admin/GeneralRequests/AccountReactivationRequest.js"),
    ),
  },
  {
    path: "general-requests/limit-management",
    element: lazy(
      () =>
        import("../../pages/Admin/GeneralRequests/limits/AdminLimitManagement.js"),
    ),
  },
  {
    path: "general-requests/provider-management",
    element: withProvider(
      lazy(
        () =>
          import("../../pages/Admin/GeneralRequests/providers/AdminProviderManagement.js"),
      ),
      [ProviderProvider],
    ),
  },
  {
    path: "organisations",
    element: lazy(
      () => import("../../pages/Admin/Organisations/AdminOrganisation.js"),
    ),
  },
  {
    path: "product-configuration",
    element: withProvider(
      lazy(
        () =>
          import("../../pages/Admin/ProductConfiguration/AdminProductConfiguration.js"),
      ),
      [ProductConfigurationProvider],
    ),
  },
  {
    path: "ProcessInstance",
    element: lazy(
      () => import("../../pages/Admin/Process/AdminProcessInstances.js"),
    ),
  },
  // {
  //   path: "/settings/user/view/:userId",
  //   element: lazy(() =>
  //     import("../../pages/Settings And More/Corporate Settings/ViewUser.jsx")
  //   ),
  // },
  {
    path: "/settings/developer-tools",
    element: lazy(
      () =>
        import("../../pages/Settings And More/Developer Tools/DeveloperTools.js"),
    ),
  },
  {
    path: "/reportviewer/*",
    element: lazy(
      () => import("../../components/Routes/ReportViewerRoutes.jsx"),
    ),
  },
  {
    path: "/deposits",
    element: withProvider(
      lazy(() => import("../../pages/Admin/Deposit/AdminDepositReport.js")),
      [DepositProvider],
    ),
  },

  {
    path: "/deposits/:depositAccountId",
    element: withProvider(
      lazy(
        () =>
          import("../../pages/Admin/Deposit/AdminDepositAccountCreation.js"),
      ),
      [DepositProvider],
    ),
  },
  {
    path: "/deposits/:depositAccountId/edit",
    element: withProvider(
      lazy(
        () =>
          import("../../pages/Admin/Deposit/AdminDepositAccountCreation.js"),
      ),
      [DepositProvider],
    ),
  },
  {
    path: "/new-deposit",
    element: withProvider(
      lazy(
        () =>
          import("../../pages/Admin/Deposit/AdminDepositAccountCreation.js"),
      ),
      [DepositProvider],
    ),
  },
  {
    path: "/deposit-fund",
    element: withProvider(
      lazy(() => import("../../pages/Admin/Deposit/AdminDepositFund.js")),
      [DepositProvider],
    ),
  },
  {
    path: "/book-management", //book-management
    element: withProvider(
      lazy(() => import("../../pages/Admin/BookManagement/NewBook.js")),
      [DepositProvider],
    ),
  },
  {
    path: "/book-management/:id", //book-management
    element: withProvider(
      lazy(() => import("../../pages/Admin/BookManagement/NewBook.js")),
      [DepositProvider],
    ),
  },
  {
    path: "/book-management/:id/edit",
    element: withProvider(
      lazy(() => import("../../pages/Admin/BookManagement/NewBook.js")),
      [DepositProvider],
    ),
  },
  {
    path: "/books", //
    element: withProvider(
      lazy(() => import("../../pages/Admin/BookManagement/books.js")),
      [DepositProvider],
    ),
  },
  {
    path: "/interbranch-accounting", //
    element: withProvider(
      lazy(
        () =>
          import("../../pages/Admin/interbranch-accounting/AdminInterbranchAccounting.js"),
      ),
      [DepositProvider],
    ),
  },
  {
    path: "/withdraw-fund",
    element: withProvider(
      lazy(() => import("../../pages/Admin/Deposit/AdminWithdrawFund.js")),
      [DepositProvider],
    ),
  },
  {
    path: "/transfer-fund",
    element: withProvider(
      lazy(() => import("../../pages/Admin/Deposit/AdminTransferFund.js")),
      [DepositProvider],
    ),
  },
  {
    path: "/all-loans",
    element: lazy(
      () => import("../../pages/Admin/LoanRequests/AdminLoanReport.js"),
    ),
  },
  {
    path: "/all-loans/:loanAccountId",
    element: withProvider(
      lazy(
        () =>
          import("../../pages/Admin/LoanRequests/AdminLoanAccountCreation.js"),
      ),
      [LoanRequestProvider],
    ),
  },
  {
    path: "/all-loans/:loanAccountId/edit",
    element: withProvider(
      lazy(
        () =>
          import("../../pages/Admin/LoanRequests/AdminLoanAccountCreation.js"),
      ),
      [LoanRequestProvider],
    ),
  },
  {
    path: "/new-loan",
    element: withProvider(
      lazy(
        () =>
          import("../../pages/Admin/LoanRequests/AdminLoanAccountCreation.js"),
      ),
      [LoanRequestProvider],
    ),
  },
  {
    path: "/cheque-registrations",
    element: lazy(
      () =>
        import("../../pages/Admin/ChequeRegistrations/AdminChequeRegistrationReport.js"),
    ),
  },
  {
    path: "/new-request",
    element: lazy(
      () =>
        import("../../pages/Admin/ChequeRegistrations/AdminChequeRegistrationCreation.js"),
    ),
  },

  {
    path: "/self-service-users",
    element: lazy(
      () => import("../../pages/Admin/UserManagement/AdminSelfServiceUsers.js"),
    ),
  },
  {
    path: "/self-service-users/:userId",
    element: lazy(
      () =>
        import("../../pages/Admin/UserManagement/AdminSelftServiceUserDetails.js"),
    ),
  },
  {
    path: "/administrative-users",
    element: lazy(
      () => import("../../pages/Admin/UserManagement/AdministrativeUsers.js"),
    ),
  },
  {
    path: "/administrative-users/:userId",
    element: lazy(
      () => import("../../pages/Admin/UserManagement/AdminUserCreation.js"),
    ),
  },
  {
    path: "/administrative-users/:userId/edit",
    element: lazy(
      () => import("../../pages/Admin/UserManagement/AdminUserCreation.js"),
    ),
  },
  {
    path: "/new-user",
    element: lazy(
      () => import("../../pages/Admin/UserManagement/AdminUserCreation.js"),
    ),
  },
  {
    path: "/roles",
    element: lazy(
      () => import("../../pages/Admin/RoleManagement/AdminRoleManagement.js"),
    ),
  },
  {
    path: "/roles/:roleId",
    element: lazy(
      () => import("../../pages/Admin/RoleManagement/AdminRoleCreation.js"),
    ),
  },
  {
    path: "/roles/:roleId/edit",
    element: lazy(
      () => import("../../pages/Admin/RoleManagement/AdminRoleCreation.js"),
    ),
  },
  {
    path: "/new-role",
    element: lazy(
      () => import("../../pages/Admin/RoleManagement/AdminRoleCreation.js"),
    ),
  },
  {
    path: "chains",
    element: lazy(
      () =>
        import("../../components/Settings/DeveloperTools/Tabs/CommandChainsTab.js"),
    ),
  },
  {
    path: "chains/new",
    element: lazy(
      () =>
        import("../../components/Settings/DeveloperTools/Tabs/CommandChainsTab.js"),
    ),
  },
  {
    path: "chains/:chainId",
    element: lazy(
      () =>
        import("../../components/Settings/DeveloperTools/Tabs/CommandChainsTab.js"),
    ),
  },
  {
    path: "chains/:chainId/edit",
    element: lazy(
      () =>
        import("../../components/Settings/DeveloperTools/Tabs/CommandChainsTab.js"),
    ),
  },
  {
    path: "webhooks",
    element: lazy(
      () =>
        import("../../components/Settings/DeveloperTools/Tabs/WebhookTab.js"),
    ),
  },
  {
    path: "secure-credentials",
    element: lazy(
      () =>
        import("../../components/Settings/DeveloperTools/Tabs/SecureCredentialsTab.js"),
    ),
  },
  {
    // path: "/settings/developer-tools/view/:id",
    path: "/views/:id",
    element: lazy(
      () =>
        import("../../pages/Settings And More/Developer Tools/ReactCodeView.js"),
    ),
  },
];

export const ProtectedSharedRoutes = [
  {
    path: "/settings",
    element: lazy(
      () => import("../../pages/Settings And More/HandleAccountType"),
    ),
  },
  {
    path: "/settings/security",
    element: lazy(
      () =>
        import("../../pages/Settings And More/Personal Settings/PersonalSecurity"),
    ),
  },
  {
    path: "/settings/security/change-password",
    element: lazy(
      () =>
        import("../../pages/Settings And More/Personal Settings/ChangePassword"),
    ),
  },
  {
    path: "/settings/security/change-pin",
    element: lazy(
      () => import("../../pages/Settings And More/Personal Settings/ChangePin"),
    ),
  },
  {
    path: "/settings/security/setup-pin",
    element: lazy(() => import("../../components/Dashboard/pin/SetUpNewPin")),
  },
  {
    path: "/settings/security/edit-question",
    element: lazy(
      () =>
        import("../../pages/Settings And More/Personal Settings/EditQuestion"),
    ),
  },
  {
    path: "/settings/security/security-questions",
    element: lazy(
      () =>
        import("../../pages/Settings And More/Personal Settings/SecurityQuestions"),
    ),
  },
  {
    path: "/settings/security/two-factor-auth",
    element: lazy(
      () =>
        import("../../pages/Settings And More/Personal Settings/TwoFactorAuth"),
    ),
  },
  {
    path: "/settings/notifications",
    element: lazy(
      () =>
        import("../../pages/Settings And More/Personal Settings/Notifications"),
    ),
  },
  {
    path: "/settings/notifications",
    element: lazy(
      () =>
        import("../../pages/Settings And More/Personal Settings/Notifications"),
    ),
  },
  {
    path: "/settings/profile",
    element: lazy(
      () => import("../../pages/Settings And More/Personal Settings/Profile"),
    ),
  },
  {
    path: "/settings/security/otp-verification",
    element: lazy(() => import("../otp-verification/OtpVerification")),
  },
  {
    path: "/settings/user/view/:userId",
    element: lazy(
      () =>
        import("../../pages/Settings And More/Corporate Settings/ViewUser.jsx"),
    ),
  },
  {
    path: "/settings/all-users",
    element: lazy(
      () => import("../../pages/Settings And More/Corporate Settings/AllUsers"),
    ),
  },
  {
    path: "/settings/user/view/:userId",
    element: lazy(
      () =>
        import("../../pages/Settings And More/Corporate Settings/ViewUser.jsx"),
    ),
  },

  // todo: this should be on shared route
  {
    path: "/settings/manage-user/create",
    element: lazy(
      () =>
        import("../../pages/Settings And More/Corporate Settings/ManageUser"),
    ),
  },

  // {
  //   path: "/validate-user",
  //   element: lazy(() =>
  //     import("../../pages/Settings And More/Corporate Settings/ValidateUser.js")
  //   ),
  // },
  // {
  //   path: "/validate-user/security-features",
  //   element: lazy(() =>
  //     import(
  //       "../../pages/Settings And More/Corporate Settings/SecurityFeatures.js"
  //     )
  //   ),
  // },

  // NOTE: /request-approval/:formId is intentionally NOT here.
  // It is registered as a PUBLIC route in AppRoutes.jsx so it works for
  // both authenticated and unauthenticated users (email approval links).
  // RequestApprovalPageV2 handles layout internally:
  //   - Authenticated users → renders with InnerLayout (sidebar)
  //   - Unauthenticated users → renders standalone (no sidebar)
];
